<template>
    <ModalComponent name="editarDatos" @close="close" style="max-height: 50%;">
        <ContentOrLoading>
            <template v-if="!loading">
                <h3 class="mb-3">Datos de su abono</h3>
                <ValidationObserver class="row" tag="form" ref="observer" @submit.prevent="submit">
                    <FormInput class="col-12 col-lg-4" label="Ayuntamiento" type="text" name="ayuntamiento" id="ayuntamiento" rules="" v-model="data.ayuntamiento" />
                    <FormInput class="col-12 col-lg-4" label="Código de provincia" type="text" name="cod_provincia" id="cod_provincia" rules="" v-model="data.cod_provincia" />
                    <FormInput class="col-12 col-lg-4" label="Código postal" type="text" name="cod_postal" id="cod_postal" rules="" v-model="data.cod_postal" />
                    <FormInput class="col-12 col-lg-4" label="Código vía domicilio" type="text" name="domicilio_cod_via" id="domicilio_cod_via" rules="" v-model="data.domicilio_cod_via" />
                    <FormInput class="col-12 col-lg-4" label="Calle domicilio" type="text" name="domicilio_calle" id="domicilio_calle" rules="" v-model="data.domicilio_calle" />
                    <FormInput class="col-12 col-lg-4" label="Número de domicilio" type="text" name="domicilio_numero" id="domicilio_numero" rules="" v-model="data.domicilio_numero" />
                    <FormInput class="col-12 col-lg-4" label="Domicilio escalera" type="text" name="domicilio_escalera" id="domicilio_escalera" rules="" v-model="data.domicilio_escalera" />
                    <FormInput class="col-12 col-lg-4" label="Piso" type="text" name="domicilio_piso" id="domicilio_piso" rules="" v-model="data.domicilio_piso" />
                    <FormInput class="col-12 col-lg-4" label="Email" type="email" name="email" id="email" rules="" v-model="data.email" />
                    <FormInput class="col-12 col-lg-4" label="Empresa" type="text" name="empresa" id="empresa" rules="" v-model="data.empresa" />
                    <FormInput class="col-12 col-lg-4" label="IBAN" type="text" name="iban" id="iban" rules="" v-model="data.iban" />
                    <FormInput class="col-12 col-lg-4" label="Localidad" type="text" name="localidad" id="localidad" rules="" v-model="data.localidad" />
                    <FormInput class="col-12 col-lg-4" label="Observaciones" type="text" name="observaciones" id="observaciones" rules="" v-model="data.observaciones" />
                    <FormInput class="col-12 col-lg-4" label="Pais" type="text" name="pais" id="pais" rules="" v-model="data.pais" />
                    <FormInput class="col-12 col-lg-4" label="Sexo" type="text" name="sexo" id="sexo" rules="" v-model="data.sexo" />
                    <FormInput class="col-12 col-lg-4" label="Teléfono móvil" type="text" name="telefono_movil" id="telefono_movil" rules="" v-model="data.telefono_movil" />
                    <FormInput class="col-12 col-lg-4" label="Teléfono FAX" type="text" name="telefono_fax" id="telefono_fax" rules="" v-model="data.telefono_fax" />
                    <FormInput class="col-12 col-lg-4" label="Teléfono oficina" type="text" name="telefono_oficina" id="telefono_oficina" rules="" v-model="data.telefono_oficina" />
                    <button type="submit" class="button ml-3" name="button" :disabled="loading">Guardar</button>
                </ValidationObserver>
            </template>
        </ContentOrLoading>
    </ModalComponent>
</template>

<script>
import ModalComponent from '@/components/backend/components/ModalComponent';

export default {

    props: ['loading', 'abono'],
    data() {
        return {
            data: this.abono.persona_info
        }
    },
    methods: {
        async submit() {
            const isValid = await this.$refs.observer.validate();  
            if(isValid) {
                this.$emit('editarDatos', this.data);
            }
        },
        close() {
            this.$emit('close', 'editarDatos');
        }
    },
    components: {
        ModalComponent
    }
}
</script>